export default {
  intro: {
    default: 'Voer de gegevens in van de persoon die het contract ondertekent.',
    gbr: 'Voer de gegevens in van de partner die het contract ondertekent.',
    gmbh: 'Voer de gegevens in van de eigenaar of directeur die het contract ondertekent.',
  },
  sections: {
    home_address: 'Huisadres',
    home_address_help: 'Waar deze persoon woont, niet het adres van het restaurant.',
  },
  form: {
    owner_first_name: {
      label: 'Voornaam',
      placeholder: 'Voornaam invoeren',
    },
    owner_last_name: {
      label: 'Achternaam',
      placeholder: 'Achternaam invoeren',
    },
    owner_dob: {
      label: 'Geboortedatum',
      placeholder: 'Datum',
    },
    owner_phone_number: {
      label: 'Telefoon',
    },
    owner_email: {
      label: 'E-mail',
      placeholder: 'E-mail invoeren',
      help: 'Dit kan afwijken van het e-mailadres waarmee u inlogt.',
    },
    owner_id_number: {
      label: 'Identificatienummer (bijv. burgerservicenummer in de VS)',
      placeholder: '123456789',
    },
  },
  buttons: {
    back: 'Terug',
    next: 'Volgende',
  },
};
